<mat-card class="track-data-margin-top-and-bottom">
  <div fxLayout="column">
    <div class="box-bottom-border" fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{mnvrStatus}}</div>
        <div class="aro-label">{{'ARO.MANEUVER_STATUS' | translate}}</div>
      </div>
      <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{isPrecise}}</div>
        <div class="aro-label">{{'ARO.PRECISE' | translate}}</div>
      </div>
    </div>
    <div class="box-bottom-border" fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{horizontalValue}}</div>
        <div class="aro-label">{{'ARO.HORIZONTAL_VALUE' | translate}} ({{accelerationUnits}})</div>
      </div>
      <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{horizontalError}}</div>
        <div class="aro-label">{{'ARO.HORIZONTAL_ERROR' | translate}} ({{accelerationUnits}})</div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{verticalValue}}</div>
        <div class="aro-label">{{'ARO.VERTICAL_VALUE' | translate}} ({{accelerationUnits}})</div>
      </div>
      <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{verticalError}}</div>
        <div class="aro-label">{{'ARO.VERTICAL_ERROR' | translate}} ({{accelerationUnits}})</div>
      </div>
    </div>
  </div>
</mat-card>
